import { processTable } from '../../../_rte-table/mando-ui.rte-table';

export default {
  methods: {
    makeTablesResponsive(rte) {
      const elements = {
        tables: rte.querySelectorAll('table'),
      };

      elements.tables.forEach((table) => {
        processTable(table);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/components/consumer/_contact-us-rap/_vue/mixins/rteMixin.js